<script>
    import { getPalIndex, updatePal } from "./services";
    import {
        niceContact,
        pals,
        show_remove,
        warning_colour,
        warning_date,
    } from "./stores";

    export let name;
    export let key;
    export let last_contact = "";
    export let notes = "";

    let contacted = false;
    let show_notes = false;
    let contact_date = getToday();
    let nice_contact = niceContact(last_contact);
    let lastContact = false;
    let ignoreStyle;
    let contactedSize = "1fr";

    function getToday() {
        let now = new Date(),
            month,
            day,
            year;

        (month = "" + (now.getMonth() + 1)),
            (day = "" + now.getDate()),
            (year = now.getFullYear());

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }

    function setIgnore() {
        let data = updatePal(key, {
            last_contacted: "-",
        })
        last_contact = "-"
        $pals.splice(data[0], 1, data[1]);
        $pals = $pals;
    }

    function setContact() {
        let data = updatePal(key, {
            last_contacted: contact_date,
        });

        if (data.length == 0) {
            console.log("Broken");
            return;
        }

        $pals.splice(data[0], 1, data[1]);
        $pals = $pals;
    }

    function deleteContact() {
        const index = getPalIndex(key);
        $pals.splice(index, 1);
        $pals = $pals;

        $show_remove = !$show_remove;
    }

    function saveNotes() {
        let data = updatePal(key, {
            notes: notes,
        });

        if (data.length == 0) {
            console.log("Broken");
            return;
        }

        $pals.splice(data[0], 1, data[1]);
        $pals = $pals;
    }

    $: {
        lastContact = lastContactChanged(last_contact);
        $warning_date;
        ignoreStyle = last_contact === "-" ? "red" : "inherit";
        contactedSize = last_contact === "-" ? "0.2fr" : "1fr";
    }

    function lastContactChanged(last_contacted) {
        if (new Date(last_contacted) < $warning_date) {
            return true;
        }
        return false;
    }
</script>

<div class="row">
    <div class="sider bl">
        <div class="name">{name}</div>
        <div class="lastcontact">
            {#if $show_remove}
                <button id="removepal" on:click={deleteContact}>
                    Remove
                </button>
            {:else if lastContact}
                <div style="background-color: {$warning_colour}">
                    {nice_contact}
                </div>
            {:else}
                <div>
                    {nice_contact}
                </div>
            {/if}
        </div>
    </div>
    <div class="sider" style="grid-template-columns: {contactedSize} 1fr">
        <button
            class:selected={contacted}
            on:click={() => {
                contacted = !contacted;
            }}
        >
            Contacted
        </button>
        <button
            class:selected={show_notes}
            on:click={() => {
                show_notes = !show_notes;
            }}
        >
            Notes
        </button>
    </div>

    {#if contacted}
        <div class="lined">
            <div class="sider sider-fx">
                <input type="date" bind:value={contact_date} />
                <div class="sider smaller">
                    <button style:background={ignoreStyle} on:click={setIgnore}>Ignore</button>
                    <button on:click={setContact}>Set</button>
                </div>
            </div>
        </div>
    {/if}

    {#if show_notes}
        <div class="notes">
            <textarea bind:value={notes} />
        </div>
        <button style="display: block; margin: auto;" on:click={saveNotes}>Save</button>
    {/if}
</div>

<style>
    div.bl {
        padding-bottom: 10px;
    }

    div.sider-fx {
        grid-template-columns: 1fr 1fr;
    }

    div.lined {
        display: grid;
    }

    div.name {
        margin-bottom: 5px;
    }

    div.row {
        min-height: 40px;
        border: 1px solid green;
        border-left: none;
        border-right: none;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .selected {
        background-color: red;
        color: white;
    }

    #removepal {
        padding: 0;
        background-color: red;
    }

    textarea {
        font-size: medium;
        width: 100%;
        min-height: 35vh;
    }
    div.smaller {
        grid-template-columns: 0.2fr 1fr;
    }
</style>
